module.exports = __webpack_public_path__ + "img/glassquality_1.c40195de.png";